function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { Dialog, Image } from 'antd-mobile';
import { getPrefixCls } from "../../utils/common";
import "./style.less";
var prefixCls = getPrefixCls('SmRetainModal');
var RetainModal = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params;
  var title = props.title,
    productInfo = props.productInfo,
    src = props.src;
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var retainModalHasShow = useRef(true);
  var timer = useRef(null);
  useImperativeHandle(ref, function () {
    return {};
  });
  var historyHandler = function historyHandler() {
    if (retainModalHasShow.current) {
      timer.current = setTimeout(function () {
        setVisible(true);
        retainModalHasShow.current = false;
      }, 0);
    }
  };
  var closeDialog = function closeDialog() {
    setVisible(false);
    if (window) {
      window.removeEventListener('popstate', historyHandler);
    }
  };
  useEffect(function () {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.history && !(productInfo !== null && productInfo !== void 0 && productInfo.hasBuy)) {
      window.history.pushState('back', '', '');
      window.addEventListener('popstate', historyHandler);
    }
    return function () {
      clearTimeout(timer.current);
      window.removeEventListener('popstate', historyHandler);
    };
  }, []);
  var DialogBody = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-dialog-container")
  }, /*#__PURE__*/React.createElement(Image, {
    style: {
      width: '100%'
    },
    src: src || 'https://tse4-mm.cn.bing.net/th/id/OIP-C.DhcMl-dN6ZO9IBkJK1qeVwHaNK?rs=1&pid=ImgDetMain'
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-dialog-body")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-dialog-button"),
    onClick: closeDialog
  }, "\u5FCD\u75DB\u62D2\u7EDD"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container-dialog-button ").concat(prefixCls, "-container-dialog-button-continue"),
    onClick: closeDialog
  }, "\u7EE7\u7EED\u6D4F\u89C8")));
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container"),
    id: title ? "me-".concat(title) : undefined
  }, isDev && /*#__PURE__*/React.createElement("div", null, "\u633D\u7559\u5F39\u5C42\u5360\u4F4D"), /*#__PURE__*/React.createElement(Dialog, {
    bodyClassName: "".concat(prefixCls, "-container-dialog"),
    visible: visible,
    content: DialogBody,
    className: "".concat(prefixCls, "-container-dialog-wrap")
  }));
});
var EnhanceRetainModal = EnhanceComponent(RetainModal);
EnhanceRetainModal.settings = setting;
export default EnhanceRetainModal;